// extracted by mini-css-extract-plugin
module.exports = {"errorText":"_3GyUW"};